import React from 'react';
import PropTypes from 'prop-types';

import Tag from '@components/Tag';

import { PRODUCT_CLICK_LOCATION } from '@conversion/constants';
import { IMAGE_SIZE } from '@services/images/constants';
import ProductTag from '@conversion/components/ProductTag';
import { onKeyUpFunction, onKeyDownFunction } from '@utils/a11y';
import { StyledContainer } from './components/Container';
import ProductItemImage from './components/Image';
import FeaturedProductsTag from './components/FeaturedProductstag';

function ProductItem({
  product,
  size,
  onClick,
  children,
  totalProducts,
  menuSection,
}) {
  const handleClick = evt => {
    const clickLocation =
      (evt && evt.target.id) || PRODUCT_CLICK_LOCATION.INFOCARD;
    onClick(product, clickLocation, menuSection);
  };

  const MAX_ITEMS_ALLOWED = 2;

  let WeeklyDiscountTag;
  if (product.discount > 0) {
    WeeklyDiscountTag = (
      <FeaturedProductsTag>
        <Tag type="deals" text={`${product.discount}% OFF`} />
      </FeaturedProductsTag>
    );
  }

  return (
    <StyledContainer
      onClick={handleClick}
      onKeyUp={e => onKeyUpFunction(e, () => onClick({ e }))}
      onKeyDown={e => onKeyDownFunction(e, () => onClick({ e }))}
      tabIndex={0}
      id={PRODUCT_CLICK_LOCATION.INFOCARD}
      size={size}
      maxContent={totalProducts <= MAX_ITEMS_ALLOWED}
    >
      {WeeklyDiscountTag}
      <ProductItemImage
        image={product.urlBackground || product.image}
        size={size}
      />
      {product?.campaignTags?.length > 0 &&
        product.campaignTags.map(c => <ProductTag key={product.id} tag={c} />)}
      {children}
    </StyledContainer>
  );
}

ProductItem.propTypes = {
  product: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    deliveryTimeMaxMinutes: PropTypes.string,
    deliveryTimeMinMinutes: PropTypes.string,
    organic: PropTypes.bool,
    restaurantId: PropTypes.number,
    restaurantName: PropTypes.string,
    restaurantUrl: PropTypes.string,
    title: PropTypes.string,
    urlBackground: PropTypes.string,
    image: PropTypes.string,
    campaignTags: PropTypes.array,
    discount: PropTypes.number,
  }).isRequired,
  size: PropTypes.oneOf(Object.values(IMAGE_SIZE)),
  onClick: PropTypes.func.isRequired,
  children: PropTypes.object.isRequired,
  totalProducts: PropTypes.number,
  menuSection: PropTypes.string,
};

ProductItem.defaultProps = {
  size: IMAGE_SIZE.MEDIUM,
};

export default ProductItem;
